<app-modal
  [open]="isOpen"
  (closed)="close()"
>
  <ng-container modal-header>
    <h2>{{ 'photographer-book-now-modal.title'|transloco }}</h2>
  </ng-container>

  <ng-container modal-body>
    <form class="book-now" [formGroup]="form" (ngSubmit)="submit()">
      <section class="book-now__section" [ngClass]="{'book-now__section--closed': !isSectionOpen('service')}">
        <button type="button" class="book-now__section-header" (click)="toggleSection('service')">
          <div class="book-now__section-title">
            <i class="fa-solid fa-camera"></i>
            <h2>{{ 'photographer-book-now-modal.service.title'|transloco }}</h2>
          </div>
          <div class="book-now__section-actions">
            @if (isSectionComplete('service')) {
              <i class="fa-solid fa-circle-check book-now__section-check"></i>
            }
            <i class="fa-solid" [ngClass]="isSectionOpen('service') ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
          </div>
        </button>
        <div class="book-now__section-body" [ngClass]="{'book-now__section-body--closed': !isSectionOpen('service')}">
          @if (photographer?.services?.length) {
            <div class="book-now__services">
              @for (service of photographer?.services; track service.id) {
                <button
                  type="button"
                  class="book-now__service"
                  [ngClass]="{'book-now__service--selected': selectedService?.id === service.id}"
                  (click)="onSelectService(service)">
                  <app-photographer-service [service]="service" [imageSize]="64"></app-photographer-service>
                </button>
              }
            </div>
          } @else {
            <p class="book-now__empty">{{ 'bookings.create-modal.service.help'|transloco }}</p>
          }
        </div>
      </section>

      <section class="book-now__section" [ngClass]="{'book-now__section--closed': !isSectionOpen('datetime')}">
        <button type="button" class="book-now__section-header" (click)="toggleSection('datetime')">
          <div class="book-now__section-title">
            <i class="fa-solid fa-calendar-days"></i>
            <h2>{{ 'marketplace.booking.create.select-date-form.select-a-date.label'|transloco }}</h2>
          </div>
          <div class="book-now__section-actions">
            @if (isSectionComplete('datetime')) {
              <i class="fa-solid fa-circle-check book-now__section-check"></i>
            }
            <i class="fa-solid" [ngClass]="isSectionOpen('datetime') ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
          </div>
        </button>
        <div class="book-now__section-body" [ngClass]="{'book-now__section-body--closed': !isSectionOpen('datetime')}">
          @if (selectedService) {
            <app-date-time-picker
              [serviceId]="selectedService.id"
              [locale]="locale"
              [orientation]="'vertical'"
              (dateSelected)="onDateSelected($event)"
              (selectionChange)="onDateTimeSelection($event)">
            </app-date-time-picker>
            @if (selectedDateTime) {
              <div class="book-now__summary">
                <span class="book-now__summary-label">{{ 'marketplace.booking.create.select-date-form.selected'|transloco }}</span>
                <div class="book-now__summary-values">
                  <p>{{ selectedDateLabel }}</p>
                  <p>{{ selectedTimeLabel }}</p>
                </div>
              </div>
            }
          } @else {
            <p class="book-now__hint">{{ 'photographer-book-now-modal.service.select-first'|transloco }}</p>
          }
        </div>
      </section>

      <section class="book-now__section book-now__section--form" [ngClass]="{'book-now__section--closed': !isSectionOpen('customer')}">
        <button type="button" class="book-now__section-header" (click)="toggleSection('customer')">
          <div class="book-now__section-title">
            <i class="fa-solid fa-user"></i>
            <h2>{{ 'photographer-book-now-modal.customer.title'|transloco }}</h2>
          </div>
          <div class="book-now__section-actions">
            @if (isSectionComplete('customer')) {
              <i class="fa-solid fa-circle-check book-now__section-check"></i>
            }
            <i class="fa-solid" [ngClass]="isSectionOpen('customer') ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
          </div>
        </button>
        <div class="book-now__section-body" [ngClass]="{'book-now__section-body--closed': !isSectionOpen('customer')}">
          <div class="book-now__grid">
            <div class="input-group">
              <label>{{ 'register.firstname.label'|transloco }}</label>
              <input
                type="text"
                formControlName="firstname"
                placeholder="{{ 'register.firstname.placeholder'|transloco }}" />
            </div>

            <div class="input-group">
              <label>{{ 'register.lastname.label'|transloco }}</label>
              <input
                type="text"
                formControlName="lastname"
                placeholder="{{ 'register.lastname.placeholder'|transloco }}" />
            </div>

            <div class="input-group book-now__grid-full">
              <label>{{ 'bookings.create-modal.email.label'|transloco }}</label>
              <input
                type="email"
                formControlName="email"
                (focus)="onEmailFocus()"
                (blur)="onEmailBlur()"
                placeholder="{{ 'bookings.create-modal.email.placeholder'|transloco }}" />
            </div>

            <div class="input-group book-now__grid-full">
              <label>{{ 'marketplace.booking.create.select-date-form.note.label'|transloco }}</label>
              <textarea
                rows="3"
                formControlName="note"
                (focus)="onNoteFocus()"
                (blur)="onNoteBlur()"
                placeholder="{{ 'marketplace.booking.create.select-date-form.note.placeholder'|transloco }}"></textarea>
            </div>
          </div>
        </div>
      </section>
    </form>
  </ng-container>

  <ng-container modal-footer>
    <div class="book-now__footer">
      @if (selectedService) {
        <div class="book-now__price">
          <span>{{ 'service.pricing.starting-at'|transloco }}</span>
          <strong>{{ getDisplayPrice(selectedService) | currency:'EUR' }}</strong>
        </div>
      }
      <div class="actions">
        <button type="button" class="button button--secondary" (click)="close()">
          {{ 'bookings.create-modal.cancel'|transloco }}
        </button>
        <button
          type="submit"
          class="button"
          [class.button--loading]="isSubmitting"
          [disabled]="isSubmitDisabled"
        >
          {{ 'photographer-book-now-modal.cta'|transloco }}
        </button>
      </div>
    </div>
  </ng-container>
</app-modal>
